export const SKELETON_COUNT = 10;

export const PRODUCT_CARD_WIDTH = {
    xs: 'calc(50% - 4px)',
    sm: 'calc(25% - 6px)',
    md: 'calc(20% - 7px)',
};
